import { LinearGradient } from 'expo-linear-gradient'
import * as React from 'react'
import { View, ViewStyle } from 'react-native'
import { SvgXml } from 'react-native-svg'

import { CardSvgs } from './card-svgs'
import { CardProps, CardTilt } from './card.base'

const [CardBlue, CardRed, CardBlack, CardGreen] = ['3A6AE4', 'B72944', '232335', '058321']
const cardTileLeft: ViewStyle = {
  // transform: [{ rotate: '-5deg' }],
}

const cardTiltRight: ViewStyle = {
  // transform: [{ rotate: '10deg' }],
  shadowColor: 'black',
  shadowOffset: {
    width: 1,
    height: 1
  },
  shadowRadius: 2
}

const gradientContainer: ViewStyle = {
  display: 'flex',
  alignItems: 'center'
}

const selectedCardContainerStyles: ViewStyle = {
  padding: 3,
  borderRadius: 4,
  width: '100%'
}

const selectedCardDotStyles: ViewStyle = {
  width: 6,
  height: 6,
  borderRadius: 4,
  position: 'absolute',
  bottom: -14
}

const disabledCardStyles: ViewStyle = {
  opacity: 0.4
}

const getCardSvg = (cardName: string, useFourColors = false) => {
  let svg = CardSvgs[cardName]
  if (useFourColors && ['D', 'C'].includes(cardName.slice(1))) {
    //NOTE: string.replaceAll() is not working in android
    svg = svg.split(CardRed).join(CardBlue)
    svg = svg.split(CardBlack).join(CardGreen)
  }
  return svg
}

export const Card = (props: CardProps) => {
  const { name, tilt, fourColor, selected = false, disabled = false } = props
  const cardName = name ? name.toUpperCase() : ''
  const svg = getCardSvg(cardName, fourColor)
  const cardStyle = tilt ? (tilt === CardTilt.right ? cardTiltRight : cardTileLeft) : {}
  return svg ? (
    selected ? (
      <View style={gradientContainer}>
        <LinearGradient
          colors={['#49CDF2', '#49CDF2', '#9444FB']}
          style={[selectedCardContainerStyles, disabled && disabledCardStyles]}
        >
          <SvgXml xml={svg} width="100%" height="100%" fill="none" style={[cardStyle]} />
        </LinearGradient>
        <LinearGradient colors={['#49CDF2', '#49CDF2', '#9444FB']} style={selectedCardDotStyles} />
      </View>
    ) : (
      <SvgXml xml={svg} width="100%" height="100%" fill="none" style={[cardStyle, disabled && disabledCardStyles]} />
    )
  ) : (
    <View />
  )
}
